import { Container, Typography } from "@mui/material";

import { useEventHeaderStyles } from "../event/useEventHeaderStyles";
import { Breadcrumbs } from "../navigation/Breadcrumbs";
import { T } from "../../util/t";

export const RegistrationPageHeader = ({ crumbs, current, title }) => {
    const classes = useEventHeaderStyles();

    return (
        <Container>
            <div className={classes.container}>
                <Breadcrumbs
                    className="no-background"
                    crumbs={crumbs}
                    current={current}
                />

                <Typography variant="h3" component="h1" className={classes.name}><T>{title}</T></Typography>
            </div>
        </Container>
    );
};
